/*!

=========================================================
* Argon Dashboard React - v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// reactstrap components
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
  Alert,
} from "reactstrap";
import ButtonLoading from "views/components/ButtonLoading";

const OTP_COOLDOWN_SECONDS = 120;

const formatOtpCooldown = (totalSeconds) => {
  const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, "0");
  const seconds = String(totalSeconds % 60).padStart(2, "0");
  return `${minutes}:${seconds}`;
};

const Login = () => {
  const email = useRef("");
  const password = useRef("");
  const otp_code = useRef("");
  const [visible, setVisible] = useState(false);
  const onDismiss = () => setVisible(false);
  const history = useHistory();
  const [errors, setErrors] = useState("");
  const { REACT_APP_API_URL } = process.env;
  const [loading, setLoading] = useState(false);
  // Seconds until "Get OTP" can be used again; 0 means ready.
  const [otpCooldown, setOtpCooldown] = useState(0);

  useEffect(() => {
    if (otpCooldown <= 0) {
      return undefined;
    }
    const timer = setTimeout(() => {
      setOtpCooldown((seconds) => seconds - 1);
    }, 1000);
    return () => clearTimeout(timer);
  }, [otpCooldown]);

  const handleSignIn = (e) => {
    console.log("fjiejfwioe");
    e.preventDefault();
    const emailValue = email.current.value;
    const passwordValue = password.current.value;
    if (emailValue === "" && passwordValue === "") {
      alert("Please fill all the fields");
      return;
    }
    setLoading(true);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let data = {
      password: passwordValue,
      verification_code: otp_code.current.value,
    };
    emailRegex.test(emailValue)
      ? (data.email = emailValue)
      : (data.phone = emailValue);
    axios
      .post(`${REACT_APP_API_URL}api/admin/login`, data)
      .then((res) => {
        if (res.data.status === "success") {
          setLoading(false);
          sessionStorage.setItem("token", res.data.data.n_token);
          sessionStorage.setItem("user_role", res.data.data.role);
          sessionStorage.setItem("user_id", res.data.data.id);
          sessionStorage.setItem("username", res.data.data.name);
          if (res.data.data.role == "ADMIN") {
            console.log("admin");
            window.location.assign("admin/index");
            window.location.reload(false);
            // history.push("/dashboard/index");
          } else if (res.data.data.role == "CS") {
            console.log("cs");
            window.location.assign("admin/orders");
            window.location.reload(false);
            // history.push("/admin/orders");
          } else {
            alert("You are not authorized to access this page");
            //delete sessionStorage
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("user_role");
            sessionStorage.removeItem("user_id");
            sessionStorage.removeItem("username");
            window.location.assign("admin/login");
            window.location.reload(false);
          }
        } else {
          setErrors(res.data.message);
          setVisible(true);
          setLoading(false);
        }
        console.log(res);
      })
      .catch((err) => {
        setLoading(false);
        setErrors(
          typeof err.response.data.message === "object"
            ? err.response.data.message.errors[0].message
            : err.response.data.message
        );
        setVisible(true);
      });
  };

  const handleSendOTP = (e) => {
    e.preventDefault();
    setLoading(true);
    let data = {
      phone: email.current.value,
      password: password.current.value,
      type: "admin",
    };
    axios
      .post(`${REACT_APP_API_URL}api/send-phone-otp-verify`, data)
      .then((res) => {
        if (res.data.status === "success") {
          setOtpCooldown(OTP_COOLDOWN_SECONDS);
          toast.success(res.data.message);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("status code ", err.response.status);
        console.log("error msg", err.response.data.message);
        if (err.response.status == 429) {
          toast.error("Too many requests, please try again 1 hr later");
        } else {
          toast.error(err.response.data.message);
        }
      });
  };

  return (
    <>
      <Col lg="5" md="7">
        <Card className="akh-auth-card border-0">
          {/* <CardHeader className="pb-5 bg-transparent">
            <div className="mt-2 text-center text-muted"></div>
            <div className="text-center btn-wrapper">
              <Button
                className="btn-neutral btn-icon"
                color="default"
                href="#pablo"
                onClick={(e) => e.preventDefault()}
              >
                <span className="btn-inner--icon">
                  <img
                    alt="..."
                    src={
                      require("../../assets/img/icons/common/github.svg")
                        .default
                    }
                  />
                </span>
                <span className="btn-inner--text">Github</span>
              </Button>
              <Button
                className="btn-neutral btn-icon"
                color="default"
                href="#pablo"
                onClick={(e) => e.preventDefault()}
              >
                <span className="btn-inner--icon">
                  <img
                    alt="..."
                    src={
                      require("../../assets/img/icons/common/google.svg")
                        .default
                    }
                  />
                </span>
                <span className="btn-inner--text">Google</span>
              </Button>
            </div>
            
          </CardHeader> */}
          <CardBody className="px-lg-5 py-lg-5">
            <h3 className="akh-auth-title">Welcome back</h3>
            <p className="akh-auth-subtitle">
              Sign in to the AKH admin dashboard
            </p>
            <Alert color="warning" isOpen={visible} toggle={onDismiss}>
              {errors}
            </Alert>
            <Form role="form" onSubmit={handleSignIn}>
              <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-email-83" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    innerRef={email}
                    placeholder="Email or Phone"
                    type="text"
                    autoComplete="new-email"
                    aria-label="Email or Phone"
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-lock-circle-open" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    innerRef={password}
                    placeholder="Password"
                    type="password"
                    autoComplete="new-password"
                    aria-label="Password"
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-key-25" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    innerRef={otp_code}
                    placeholder="SMS OTP Code"
                    type="text"
                    autoComplete="off"
                    aria-label="SMS OTP Code"
                  />
                  <Button
                    type="button"
                    color="primary"
                    className="px-3 text-nowrap font-mono"
                    disabled={loading || otpCooldown > 0}
                    onClick={handleSendOTP}
                  >
                    {otpCooldown > 0 ? formatOtpCooldown(otpCooldown) : "Get OTP"}
                  </Button>
                </InputGroup>
              </FormGroup>

              <div className="custom-control custom-control-alternative custom-checkbox">
                <input
                  className="custom-control-input"
                  id=" customCheckLogin"
                  type="checkbox"
                />
                {/* <label
                  className="custom-control-label"
                  htmlFor=" customCheckLogin"
                >
                  <span className="text-muted">Remember me</span>
                </label> */}
              </div>
              <div className="text-center">
                <ButtonLoading
                  className="m-1 "
                  type="submit"
                  loading={loading}
                  onClick={handleSignIn}
                  disabled={loading}
                  color="info"
                  block={!loading}
                  outline={false}
                >
                  Sign in
                </ButtonLoading>
                {/* <Button className="my-4" color="primary" type="submit">
                  Sign in
                </Button> */}
              </div>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default Login;
